import gql from 'graphql-tag';
import { activityFeedItem } from '@shared/api/fragments/activity';

export const listActivityFeedItems = gql`
  query ListActivityFeedItemsQuery($input: ListActivityFeedItems!) {
    listActivityFeedItems(input: $input) {
      items {
        ...ActivityFeedItem
      }
      nextCursor
    }
  }

  ${activityFeedItem}
`;
